
import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { AddonsService } from 'app/shared/services/addons.service';
import { TravelProductService, GetCartTotalOptions, CartItemOptions } from 'app/shared/services/travel-product.service';
import { Pass, Addon, Package } from 'app/shared/models/booking.model';


@Injectable()
export class CartTotalService {


    constructor(private travelProductService: TravelProductService,
        private addonsService: AddonsService) {
    }

    postCartTotal = (options: GetCartTotalOptions, success, error, loading, finished) => {
        if (!!loading) {
            loading();
        }
        this.travelProductService.postCartTotal(options)
            .subscribe(success, error, finished);
    }
    getCartTotal = (bookingGUID: string, success, error, loading, finished) => {
        if (!!loading) {
            loading();
        }
        this.travelProductService.getCartTotal(bookingGUID)
            .subscribe(success, error, finished);
    }

    getPassCartTotalOptions(passAsAPackage: Package, addons: Addon[], promo: string): GetCartTotalOptions {

        let cartItems: CartItemOptions[] = [], farePrice, fareBasisCode;

        if (passAsAPackage) {
            farePrice = passAsAPackage.FareTypes[0].Farebasis.TotalPrice,
                fareBasisCode = passAsAPackage.FareTypes[0].Farebasis.FarebasisCode;
        }
        const item = new CartItemOptions();
        item.productCode = null;
        item.Type = GxConstants.FARETYPE_CODES.FARE_PRICE;
        item.SalePriceUnit = farePrice;
        item.Quantity = 1;
        item.PromoCode = promo;
        // FARE PRICE
        cartItems.push(item);

        // ADD THIRD PARTY PRODUCTS (AND INSURANCE)
        cartItems = _.union(cartItems, this.addonsService.getAddonsAnswers(addons));

        const options = new GetCartTotalOptions();
        options.Passengers = 1;
        options.Farebasis = fareBasisCode;
        options.CartItems = cartItems;
        return options;

    }

    getExpressCartTotalOptions(travels, passengersQty, addons, freeTrip, customerGuid): GetCartTotalOptions {

        let cartItems: CartItemOptions[] = [],
            farePrice = 0,
            fuelSurcharge = 0,
            insuredFarePrice = 0;

        // Add up totals from each trip
        _.each(travels,
            (travel: any) => {
                const fare = travel.RouteOptions[0].Fares[0];
                farePrice += fare.Price;
                fuelSurcharge += fare.TotalFuelSurcharge;
                if (fare.Insurance === true) {
                    insuredFarePrice += fare.Price;
                }

                const farePriceItem = new CartItemOptions();
                farePriceItem.productCode = null;
                farePriceItem.Type = GxConstants.FARETYPE_CODES.FARE_PRICE;
                farePriceItem.SalePriceUnit = fare.Price;
                farePriceItem.Quantity = passengersQty;
                farePriceItem.ProductReference = travel.TravelGUID;
                farePriceItem.FareReference = fare.FareGUID;
                farePriceItem.ProductType = '5'; // Express ProductTypeId
                // FARE PRICE
                cartItems.push(farePriceItem);
            });

        // const farePriceItem = new CartItemOptions();
        // farePriceItem.productCode = null;
        // farePriceItem.Type = GxConstants.FARETYPE_CODES.FARE_PRICE;
        // farePriceItem.SalePriceUnit = farePrice;
        // farePriceItem.Quantity = passengersQty;
        // // FARE PRICE
        // cartItems.push(farePriceItem);

        const fuelSurchargeItem = new CartItemOptions();
        fuelSurchargeItem.productCode = null;
        fuelSurchargeItem.Type = GxConstants.FARETYPE_CODES.FULL_SURCHARGE;
        fuelSurchargeItem.SalePriceUnit = fuelSurcharge;
        fuelSurchargeItem.Quantity = passengersQty;
        // FUEL SURCHARGE
        cartItems.push(fuelSurchargeItem);
        // ADD THIRD PARTY PRODUCTS (AND INSURANCE)
        cartItems = _.union(cartItems, this.addonsService.getAddonsAnswers(addons));
        console.log('cartItems', cartItems);
        cartItems.forEach((cartItem, index) => {
            if (cartItem.Type === GxConstants.FARETYPE_CODES.INSURANCE) {
                cartItem.SalePriceUnit = insuredFarePrice;
            }

            if (cartItem.Type === GxConstants.FARETYPE_CODES.THIRD_PARTY) {
                if (cartItem.productCode === null) {
                    cartItem = null;
                    cartItems.splice(index, 1);
                } else {
                }
            }
        });
        
        const options = new GetCartTotalOptions();
        options.Passengers = passengersQty;
        options.FreeTrip = freeTrip;
        options.CustomerGUID = customerGuid;
        options.CartItems = cartItems;
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cart-total.service.ts